import { 
  Box, IconButton, Typography, Paper, Chip
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ForestIcon from '@mui/icons-material/Forest';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import LayersIcon from '@mui/icons-material/Layers';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './UnifiedDashboard.css';

const UnifiedDashboard = ({ onSectionClick, activeSection, onBackClick }) => {
  const dashboardSections = [
    {
      id: 'logistics',
      title: 'LOGISTICS',
      icon: <InventoryIcon />,
      color: '#2c5530',
      gradient: 'linear-gradient(135deg, #2c5530 0%, #1b4332 100%)',
      reports: [
        { id: 'sticker', label: 'Sticker' },
        { id: 'packing', label: 'Packing List' },
        { id: 'load', label: 'Load List' },
        { id: 'main', label: 'Main List' },
        { id: 'orderlist', label: 'Order List - Date Wise' },
        { id: 'orderlistdelivery', label: 'Order List - Delivery Date Wise' },
        { id: 'pendingorders', label: 'Pending Orders' },
        { id: 'pendingsuborders', label: 'Pending Sub Orders' },
        { id: 'aacconnection', label: 'Get AAC Connection' },
        { id: 'containerloading', label: 'Container Loading - Client Wise' },
        { id: 'containermonthwise', label: 'Container Month Wise' },
        { id: 'containerlistdatewise', label: 'Container List - Date Wise' },
        { id: 'loadingsale', label: 'Loading / Sale - Date Wise' },
        { id: 'ordertracking', label: 'Order Tracking' },
        { id: 'shippingschedule', label: 'Shipping Schedule' },
        { isDivider: true, label: 'Testing / Experimental' },
        // { id: 'packingv2', label: 'Packing List V2', isNew: true },
        { id: 'packingv3', label: 'Packing List V3 (Forest/AAC)' },
        { id: 'loadv2', label: 'Load List V2' },
        { id: 'mainv2', label: 'Main List V2' },
        { id: 'stickerv2', label: 'Sticker V2 (Forest/AAC)' },
      ]
    },
    {
      id: 'summary',
      title: 'SUMMARY',
      icon: <SummarizeIcon />,
      color: '#1565c0',
      gradient: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
      reports: [
        { id: 'currentmonthsummary', label: 'Current Month Summary' },
        { id: 'datewisesummary', label: 'Date Wise Summary' },
        { id: 'plywooddailyoperationssummary', label: 'Daily Operations' },
        { id: 'rejectedpcssummary', label: 'Rejected PCS Summary' },
        { id: 'dailymatproduction', label: 'Daily Mat Production' },
        { id: 'dailyloadingsummary', label: 'Daily Loading Summary' },
        { id: 'criticalstockreport', label: 'Critical Stock Report', isNew: true }
      ]
    },
    {
      id: 'logs',
      title: 'LOG SECTION',
      icon: <ForestIcon />,
      color: '#6d4c41',
      gradient: 'linear-gradient(135deg, #6d4c41 0%, #3e2723 100%)',
      reports: [
        { id: 'currentlogstock',   label: 'Current Log Stock' },
        { id: 'logclosingstock',   label: 'Log Closing Stock' },
        { id: 'logbuyingsummary',  label: 'Log Buying Summary' },
        { id: 'loginvoicesummary', label: 'Log Invoice Summary' },
        { id: 'logcuttingsummary', label: 'Log Cutting Summary' },
        { id: 'logboardeaureport', label: 'Log Boardeau (Inward) Report' },
        { id: 'logcuttingreport',  label: 'Log Cutting Summary Report' },
        { id: 'logstockreport',    label: 'Log Current Stock Report' },
        { id: 'logbordeaureportv2', label: 'Bordereau Datewise Summary', isNew: true },
      ]
    },
    {
      id: 'plywood',
      title: 'PLYWOOD',
      icon: <PrecisionManufacturingIcon />,
      color: '#e65100',
      gradient: 'linear-gradient(135deg, #e65100 0%, #bf360c 100%)',
      reports: [
        { id: 'dailyhotpressproduction', label: 'Daily Hotpress Production' },
        { id: 'dailyhotpressreportv2', label: 'Daily Hotpress Report V2' },
        { id: 'dailyrefacereportv2', label: 'Daily Reface Report V2' },
        { id: 'dailysandingreport', label: 'Daily Sanding Report' },
        { id: 'dailysandingbymachinereport', label: 'Sanding Report — By Machine' },
        { id: 'dailyddsawreport', label: 'Daily DDSaw Report' },
        { id: 'dailyddsawbymachinereport', label: 'DDSaw Report — By Machine' },
        { id: 'dailycaliberatorreport', label: 'Daily Caliberator Report' },
        { id: 'dailycaliberatorbymachinereport', label: 'Caliberator Report — By Machine' },
        { id: 'dailyprepressreport', label: 'Daily Reface Production Summary' },
        { id: 'gradingpalletreport',       label: 'Grading Pallet Report' },
        { id: 'packedpalletstockreport',   label: 'Packed Pallet Stock Report', isNew: true },
        { id: 'hotpressdelay', label: 'Hotpress Delay Report', isNew: true },
        { id: 'coldpresspending', label: 'Hotpress Shift Handover', isNew: true },
        { id: 'breakdownreport', label: 'Daily Breakdown Report', isNew: true },
        { id: 'hotpresstransreport', label: 'HP Trans Report (Cycle Detail)', isNew: true },
        { id: 'refacetransreport',   label: 'HP Reface Trans Report (Cycle Detail)', isNew: true },
      ]
    },
    {
      id: 'veneer',
      title: 'VENEER',
      icon: <LayersIcon />,
      color: '#6a1b9a',
      gradient: 'linear-gradient(135deg, #6a1b9a 0%, #4a148c 100%)',
      reports: [
        { id: 'dailyclipperreport',             label: 'Daily Clipper Report',                         isNew: true },
        { id: 'dailyclippersizethicknessreport', label: 'Daily Clipper Report — Size, Thickness Wise',  isNew: true },
        { id: 'dailydryerreport',               label: 'Daily Dryer Report — By Machine',              isNew: true },
        { id: 'dailycorecomposerreport',        label: 'Daily Core Composer Report — By Machine',      isNew: true },
      ]
    }
  ];

  const handleBackToDashboard = () => {
    if (onBackClick) {
      onBackClick();
    }
  };

  // Section view - showing reports for selected section
  if (activeSection) {
    const section = dashboardSections.find(s => s.id === activeSection);
    
    return (
      <Box className="unified-dashboard" sx={{ 
        minHeight: '100vh',
        overflow: 'visible'
      }}>
        {/* Header */}
        <Box sx={{ 
          background: section.gradient,
          color: 'white',
          p: { xs: 2, md: 3 },
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          position: 'sticky',
          top: 0,
          zIndex: 10
        }}>
          <IconButton 
            onClick={handleBackToDashboard} 
            sx={{ 
              color: 'white',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ fontSize: { xs: 24, md: 28 } }}>
              {section.icon}
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: '0.5px' }}>
              {section.title}
            </Typography>
          </Box>
          <Box sx={{ ml: 'auto' }}>
            <Chip 
              label={`${section.reports.length} Reports`}
              sx={{ 
                backgroundColor: 'rgba(255,255,255,0.15)', 
                color: 'white',
                fontWeight: 500,
                border: '1px solid rgba(255,255,255,0.2)'
              }}
            />
          </Box>
        </Box>

        {/* Reports Grid */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'flex-start',
          justifyContent: 'center',
          p: { xs: 1.5, md: 4 },
          pb: { xs: 4, md: 5 },
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        }}>
          <Box sx={{ 
            display: 'grid',
            gridTemplateColumns: { 
              xs: '1fr',
              sm: 'repeat(2, 1fr)', 
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)'
            },
            gap: { xs: 1.5, md: 3.5 },
            maxWidth: '1400px',
            width: '100%',
            alignContent: 'start'
          }}>
            {section.reports.map((report, index) => {
              // Divider item — spans full grid width
              if (report.isDivider) {
                return (
                  <Box
                    key={`divider-${index}`}
                    sx={{
                      gridColumn: '1 / -1',
                      display: 'flex', alignItems: 'center',
                      py: 1.5, mt: 1
                    }}
                  >
                    <Box sx={{ flex: 1, height: '2px', background: 'linear-gradient(90deg, transparent 0%, #1b4332 50%, transparent 100%)', borderRadius: 1 }} />
                  </Box>
                );
              }
              return (
              <Paper
                key={report.id}
                className="report-pill"
                onClick={() => onSectionClick(report.id)}
                sx={{
                  height: { xs: 'auto', md: 160 },
                  minHeight: { xs: 80, md: 'auto' },
                  width: '100%',
                  maxWidth: { md: '300px' },
                  borderRadius: 3,
                  backgroundColor: 'white',
                  border: `3px solid ${section.color}20`,
                  display: 'flex',
                  flexDirection: { xs: 'row', md: 'column' },
                  alignItems: 'center',
                  justifyContent: { xs: 'flex-start', md: 'center' },
                  cursor: 'pointer',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
                  animationDelay: `${index * 0.1}s`,
                  position: 'relative',
                  overflow: 'hidden',
                  p: { xs: 2, md: 3 },
                  gap: { xs: 1.5, md: 0 },
                  '&:hover': {
                    background: section.gradient,
                    color: 'white',
                    transform: { xs: 'none', md: 'translateY(-8px) scale(1.03)' },
                    boxShadow: `0 16px 48px ${section.color}40`,
                    borderColor: 'transparent'
                  },
                  '&:active': {
                    transform: 'scale(0.98)',
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '-100%',
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                    transition: 'left 0.6s',
                  },
                  '&:hover::before': {
                    left: '100%',
                  }
                }}
              >
                {/* NEW badge pimple */}
                {report.isNew && (
                  <Box sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    backgroundColor: '#e53935',
                    color: '#ffffff',
                    fontSize: '0.6rem',
                    fontWeight: 800,
                    letterSpacing: '0.8px',
                    px: 0.9,
                    py: 0.3,
                    borderRadius: '20px',
                    lineHeight: 1.4,
                    boxShadow: '0 2px 6px rgba(229,57,53,0.5)',
                    animation: 'pulse-badge 1.8s ease-in-out infinite',
                    '@keyframes pulse-badge': {
                      '0%': { boxShadow: '0 0 0 0 rgba(229,57,53,0.6)' },
                      '70%': { boxShadow: '0 0 0 6px rgba(229,57,53,0)' },
                      '100%': { boxShadow: '0 0 0 0 rgba(229,57,53,0)' },
                    },
                    zIndex: 2,
                  }}>
                    NEW
                  </Box>
                )}

                {/* Icon */}
                <Box sx={{ 
                  width: { xs: 40, md: 52 },
                  height: { xs: 40, md: 52 },
                  borderRadius: '50%',
                  backgroundColor: `${section.color}15`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: { xs: 0, md: 2.5 },
                  flexShrink: 0,
                  transition: 'all 0.3s ease'
                }}>
                  <Box sx={{ 
                    fontSize: { xs: 20, md: 26 },
                    color: section.color,
                    opacity: 0.8
                  }}>
                    📊
                  </Box>
                </Box>

                {/* Report Title */}
                <Box sx={{ flex: { xs: 1, md: 'none' }, textAlign: { xs: 'left', md: 'center' } }}>
                  <Typography sx={{ 
                    fontWeight: 600, 
                    fontSize: { xs: '0.95rem', md: '1.1rem' },
                    letterSpacing: '0.3px',
                    lineHeight: 1.3,
                    mb: { xs: 0, md: 1.5 }
                  }}>
                    {report.label}
                  </Typography>
                </Box>

                {/* Accent line — desktop only */}
                <Box sx={{
                  display: { xs: 'none', md: 'block' },
                  width: '40px',
                  height: '3px',
                  backgroundColor: section.color,
                  borderRadius: '2px',
                  opacity: 0.6,
                  transition: 'all 0.3s ease'
                }} />
              </Paper>
              );
            })}
          </Box>
        </Box>
      </Box>
    );
  }

  // Main dashboard
  return (
    <Box className="unified-dashboard">
      <Box sx={{ 
        minHeight: { xs: 'auto', md: '100vh' },
        display: 'flex', 
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'center',
        p: { xs: 2, md: 3 },
        pb: { xs: 4, md: 3 }
      }}>
        {/* Desktop Layout */}
        <Box sx={{
          display: { xs: 'none', md: 'block' },
          width: '100%',
          maxWidth: '1200px'
        }}>
          {/* First Row - 3 Cards */}
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 3,
            mb: 3,
            height: '200px'
          }}>
            {dashboardSections.slice(0, 3).map((section, index) => (
                <Paper
                  key={section.id}
                  className="section-card"
                  onClick={() => onSectionClick('section-' + section.id)}
                  sx={{
                    background: section.gradient,
                    color: 'white',
                    cursor: 'pointer',
                    borderRadius: 3,
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    animationDelay: `${index * 0.1}s`,
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: `0 12px 40px ${section.color}40`,
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Box sx={{ fontSize: 40, opacity: 0.9 }}>
                      {section.icon}
                    </Box>
                  </Box>
                  <Typography sx={{ 
                    fontSize: '1.4rem',
                    fontWeight: 700, 
                    textAlign: 'center',
                    mb: 2,
                    letterSpacing: '0.5px'
                  }}>
                    {section.title}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Chip 
                      label={`${section.reports.length} Reports`}
                      size="small"
                      sx={{ 
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        color: 'white',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        border: '1px solid rgba(255,255,255,0.2)'
                      }}
                    />
                    <IconButton 
                      size="small"
                      sx={{ 
                        color: 'white',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        '&:hover': { 
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          transform: 'scale(1.1)'
                        }
                      }}
                    >
                      <ArrowForwardIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Paper>
              ))}
            </Box>

            {/* Second Row - 2 Cards Centered */}
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 3,
              maxWidth: '800px',
              mx: 'auto',
              height: '200px'
            }}>
              {dashboardSections.slice(3, 5).map((section, index) => (
                <Paper
                  key={section.id}
                  className="section-card"
                  onClick={() => onSectionClick('section-' + section.id)}
                  sx={{
                    background: section.gradient,
                    color: 'white',
                    cursor: 'pointer',
                    borderRadius: 3,
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    animationDelay: `${(index + 3) * 0.1}s`,
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: `0 12px 40px ${section.color}40`,
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Box sx={{ fontSize: 40, opacity: 0.9 }}>
                      {section.icon}
                    </Box>
                  </Box>
                  <Typography sx={{ 
                    fontSize: '1.4rem',
                    fontWeight: 700, 
                    textAlign: 'center',
                    mb: 2,
                    letterSpacing: '0.5px'
                  }}>
                    {section.title}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Chip 
                      label={`${section.reports.length} Reports`}
                      size="small"
                      sx={{ 
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        color: 'white',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        border: '1px solid rgba(255,255,255,0.2)'
                      }}
                    />
                    <IconButton 
                      size="small"
                      sx={{ 
                        color: 'white',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        '&:hover': { 
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          transform: 'scale(1.1)'
                        }
                      }}
                    >
                      <ArrowForwardIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>

          {/* Mobile Layout */}
          <Box sx={{
            display: { xs: 'flex', md: 'none' },
            flexDirection: 'column',
            gap: 2,
            width: '100%',
            justifyContent: 'center',
            alignItems: 'stretch'
          }}>
            {dashboardSections.map((section, index) => (
              <Paper
                key={`mobile-${section.id}`}
                className="section-card"
                onClick={() => onSectionClick('section-' + section.id)}
                sx={{
                  background: section.gradient,
                  color: 'white',
                  cursor: 'pointer',
                  borderRadius: 3,
                  p: 2.5,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 6px 24px rgba(0,0,0,0.15)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  animationDelay: `${index * 0.1}s`,
                  minHeight: '80px',
                  width: '100%',
                  '&:active': {
                    transform: 'scale(0.98)',
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, height: '100%' }}>
                  <Box sx={{ fontSize: 32, opacity: 0.9, flexShrink: 0 }}>
                    {section.icon}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ 
                      fontSize: '1.1rem',
                      fontWeight: 700, 
                      letterSpacing: '0.5px',
                      mb: 0.5
                    }}>
                      {section.title}
                    </Typography>
                    <Chip 
                      label={`${section.reports.length} Reports`}
                      size="small"
                      sx={{ 
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        color: 'white',
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        height: 20
                      }}
                    />
                  </Box>
                  <IconButton 
                    size="small"
                    sx={{ 
                      color: 'white',
                      backgroundColor: 'rgba(255,255,255,0.15)',
                      flexShrink: 0,
                      '&:hover': { 
                        backgroundColor: 'rgba(255,255,255,0.25)',
                      }
                    }}
                  >
                    <ArrowForwardIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Paper>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default UnifiedDashboard;